/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './template-medication.reducer';

export const TemplateMedication = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const templateMedicationList = useAppSelector(state => state.templateMedication.entities);
  const loading = useAppSelector(state => state.templateMedication.loading);
  const totalItems = useAppSelector(state => state.templateMedication.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="template-medication-heading" data-cy="TemplateMedicationHeading">
        <Translate contentKey="tinyMedicRestApp.templateMedication.home.title">Template Medications</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.templateMedication.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/template-medication/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.templateMedication.home.createLabel">Create new Template Medication</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.templateMedication.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {templateMedicationList && templateMedicationList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.templateMedication.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('repetition')}>
                  <Translate contentKey="tinyMedicRestApp.templateMedication.repetition">Repetition</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('repetition')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.templateMedication.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.templateMedication.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.templateMedication.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.templateMedication.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.templateMedication.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('prescribedCount')}>
                  <Translate contentKey="tinyMedicRestApp.templateMedication.prescribedCount">Prescribed Count</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('prescribedCount')} />
                </th>
                <th className="hand" onClick={sort('indication')}>
                  <Translate contentKey="tinyMedicRestApp.templateMedication.indication">Indication</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('indication')} />
                </th>
                <th className="hand" onClick={sort('daysFrequency')}>
                  <Translate contentKey="tinyMedicRestApp.templateMedication.daysFrequency">Days Frequency</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('daysFrequency')} />
                </th>
                <th className="hand" onClick={sort('endDate')}>
                  <Translate contentKey="tinyMedicRestApp.templateMedication.endDate">End Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('endDate')} />
                </th>
                <th className="hand" onClick={sort('dose')}>
                  <Translate contentKey="tinyMedicRestApp.templateMedication.dose">Dose</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dose')} />
                </th>
                <th className="hand" onClick={sort('route')}>
                  <Translate contentKey="tinyMedicRestApp.templateMedication.route">Route</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('route')} />
                </th>
                <th className="hand" onClick={sort('templateItemType')}>
                  <Translate contentKey="tinyMedicRestApp.templateMedication.templateItemType">Template Item Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('templateItemType')} />
                </th>
                <th className="hand" onClick={sort('medicineName')}>
                  <Translate contentKey="tinyMedicRestApp.templateMedication.medicineName">Medicine Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('medicineName')} />
                </th>
                <th className="hand" onClick={sort('doseInstructions')}>
                  <Translate contentKey="tinyMedicRestApp.templateMedication.doseInstructions">Dose Instructions</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('doseInstructions')} />
                </th>
                <th className="hand" onClick={sort('tmType')}>
                  <Translate contentKey="tinyMedicRestApp.templateMedication.tmType">Tm Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('tmType')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.templateMedication.consumable">Consumable</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.templateMedication.implant">Implant</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.templateMedication.prescription">Prescription</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {templateMedicationList.map((templateMedication, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/template-medication/${templateMedication.id}`} color="link" size="sm">
                      {templateMedication.id}
                    </Button>
                  </td>
                  <td>{templateMedication.repetition}</td>
                  <td>{templateMedication.active ? 'true' : 'false'}</td>
                  <td>{templateMedication.cursor}</td>
                  <td>{templateMedication.lastUpdated}</td>
                  <td>{templateMedication.microSec}</td>
                  <td>{templateMedication.timestampEntry}</td>
                  <td>{templateMedication.prescribedCount}</td>
                  <td>{templateMedication.indication}</td>
                  <td>{templateMedication.daysFrequency}</td>
                  <td>{templateMedication.endDate}</td>
                  <td>{templateMedication.dose}</td>
                  <td>{templateMedication.route}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.TemplateItemType.${templateMedication.templateItemType}`} />
                  </td>
                  <td>{templateMedication.medicineName}</td>
                  <td>{templateMedication.doseInstructions}</td>
                  <td>{templateMedication.tmType}</td>
                  <td>
                    {templateMedication.consumable ? (
                      <Link to={`/consumable/${templateMedication.consumable.id}`}>{templateMedication.consumable.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {templateMedication.implant ? (
                      <Link to={`/implant/${templateMedication.implant.id}`}>{templateMedication.implant.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {templateMedication.prescription ? (
                      <Link to={`/template-prescription/${templateMedication.prescription.id}`}>{templateMedication.prescription.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/template-medication/${templateMedication.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/template-medication/${templateMedication.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/template-medication/${templateMedication.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.templateMedication.home.notFound">No Template Medications found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={templateMedicationList && templateMedicationList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default TemplateMedication;
